import { SET_CURRENT_ECHO } from './echo.type'

export const setCurrentEcho = (data) => async (dispatch) => {
    dispatch({
        type: SET_CURRENT_ECHO,
        payload: data,
    })
}
